import {
	ComponentType,
	createElement,
	ForwardedRef,
	forwardRef,
	ForwardRefExoticComponent,
	PropsWithoutRef,
	RefAttributes,
} from 'react';
import { ArchbaseErrorBoundary } from './ArchbaseErrorBoundary';
import { ArchbaseErrorBoundaryProps } from './types';

export function withArchbaseErrorBoundary<Props extends Object>(
	component: ComponentType<Props>,
	errorBoundaryProps: ArchbaseErrorBoundaryProps,
): any {
	const Wrapped = forwardRef((props: any, ref: any) =>
		createElement(ArchbaseErrorBoundary, errorBoundaryProps, createElement(component, { ...props, ref })),
	);

	const name = component.displayName || component.name || 'Unknown';
	Wrapped.displayName = `withErrorBoundary(${name})`;

	return Wrapped;
}
